import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { CLIENTS_REPOSITORY } from '../domain/repositories/clients.repository';
import { LOCAL_CLIENTS_REPOSITORY } from '../domain/repositories/local-clients.repository';
import { CLIENT_DOCUMENTS_REPOSITORY } from '../domain/repositories/client-documents.repository';
import { CLIENT_PRESCRIPTIONS_REPOSITORY } from '../domain/repositories/client-prescriptions.repository';
import { ClientsRemoteDatasource } from './datasources/remote/clients.remote-datasource';
import { LocalClientsRemoteDatasource } from './datasources/remote/local-clients.remote-datasource';
import { ClientDocumentsRemoteDatasource } from './datasources/remote/client-documents.remote-datasource';
import { ClientPrescriptionsRemoteDatasource } from './datasources/remote/client-prescriptions.remote-datasource';
import { TagCatalogRemoteDatasource } from './datasources/remote/tag-catalog.remote-datasource';
import { ClientMapper } from './mappers/client.mapper';
import { ClientClinicalHistoryMapper } from './mappers/clinical-history.mapper';
import { InvoiceMapper } from './mappers/invoice.mapper';
import { EstimateMapper } from './mappers/estimate.mapper';
import { ConsentMapper } from './mappers/consent.mapper';
import { ClientAppointmentMapper } from './mappers/client-appointment.mapper';
import { ClientProfessionalMapper } from './mappers/client-professional.mapper';
import { LocalClientMapper } from './mappers/local-client.mapper';
import { ClientReceivedDocumentMapper } from './mappers/client-received-document.mapper';
import { TagMapper } from './mappers/tag.mapper';
import { ClientsRepositoryImpl } from './repositories/clients.repository.impl';
import { LocalClientsRepositoryImpl } from './repositories/local-clients.repository.impl';
import { ClientDocumentsRepositoryImpl } from './repositories/client-documents.repository.impl';
import { ClientPrescriptionsRepositoryImpl } from './repositories/client-prescriptions.repository.impl';
import { TagCatalogRepositoryImpl } from './repositories/tag-catalog.repository.impl';
import { TAG_CATALOG_REPOSITORY } from '../domain/repositories/tag-catalog.repository';
import {
  CLIENT_CONSULTATION_SECTIONS_GATEWAY,
} from '@features/web/patients/domain/repositories/client-consultation-sections.gateway';
import { ClientConsultationSectionsGateway } from './repositories/client-consultation-sections.gateway.impl';

export function provideClientsData(): EnvironmentProviders {
  return makeEnvironmentProviders([
    ClientsRemoteDatasource,
    LocalClientsRemoteDatasource,
    ClientDocumentsRemoteDatasource,
    ClientPrescriptionsRemoteDatasource,
    TagCatalogRemoteDatasource,
    ClientMapper,
    ClientClinicalHistoryMapper,
    InvoiceMapper,
    EstimateMapper,
    ConsentMapper,
    ClientAppointmentMapper,
    ClientProfessionalMapper,
    LocalClientMapper,
    ClientReceivedDocumentMapper,
    TagMapper,
    { provide: CLIENTS_REPOSITORY, useClass: ClientsRepositoryImpl },
    { provide: LOCAL_CLIENTS_REPOSITORY, useClass: LocalClientsRepositoryImpl },
    { provide: CLIENT_DOCUMENTS_REPOSITORY, useClass: ClientDocumentsRepositoryImpl },
    { provide: CLIENT_PRESCRIPTIONS_REPOSITORY, useClass: ClientPrescriptionsRepositoryImpl },
    { provide: TAG_CATALOG_REPOSITORY, useClass: TagCatalogRepositoryImpl },
    { provide: CLIENT_CONSULTATION_SECTIONS_GATEWAY, useClass: ClientConsultationSectionsGateway },
  ]);
}
